import { Box, Collapse } from "@chakra-ui/react";
import React, { useState } from "react";
import useRequest from "../hooks/useRequest";
import { getTemaSolicitacao } from "~services/GlobalServices";
import { cpfOrCnpjMask } from "~hooks/useHelpers";

function RequestCard({ data, ReenviarSolicitacao, NovaSolicitacao }) {
  const [isObsOpen, setIsObsOpen] = useState(false);

  const StatusFlag = ({ status, className }) => {
    const statusFlag = {
      pendente: (
        <p className={`text-pendente font-bold text-lg flex items-center gap-3 ${className}`}>
          Pendente
          <span className="w-4 h-4 rounded-full bg-pendente" />
        </p>
      ),
      concluido: (
        <p className={`text-concluido font-bold text-lg flex items-center gap-3 ${className}`}>
          Concluído
          <span className="w-4 h-4 rounded-full bg-concluido" />
        </p>
      ),
      recusado: (
        <p className={`text-recusado font-bold text-lg flex items-center gap-3 ${className}`}>
          Recusado
          <span className="w-4 h-4 rounded-full bg-recusado" />
        </p>
      ),
      erro: (
        <p className={`text-recusado font-bold text-lg flex items-center gap-3 ${className}`}>
          Erro na Solicitação
          <span className="w-4 h-4 rounded-full bg-recusado" />
        </p>
      ),
    };
    return statusFlag[status];
  };

  // Trata a string pra separar {nome} e {cpf/cnpj}
  const hyphenPosition = data.descricaoCliente?.indexOf("-");
  let cpfOrCnpj = data.descricaoCliente.substring(hyphenPosition).replace(/\D/g, "");
  cpfOrCnpj = cpfOrCnpjMask(cpfOrCnpj);
  const nameOnly = data.descricaoCliente.substring(0, hyphenPosition);
  //

  /**
   * Se a informação contiver dinheiro formata como moeda
   * @param {string} infoPlus
   * @returns {string}
   */
  const displayInfoPlus = (infoPlus) => {
    const numberFollowedByComma = /[\d]+\,[\d]+/g;
    const infoHasMoney = infoPlus?.match(numberFollowedByComma);
    if (infoHasMoney) {
      return infoPlus.replace(numberFollowedByComma, (match) => {
        const numberedValue = +match.replace(",", ".");
        return Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(numberedValue);
      });
    }
    return infoPlus;
  };

  const temas = getTemaSolicitacao();
  const colorStatus = {
    1: "pendente",
    2: "concluido",
    3: "recusado",
    4: "erro",
  };
  const formatedStatus = (status) => {
    return colorStatus[status];
  };

  return (
    <div className="bg-white rounded-lg first:mt-0 mt-4 pb-2">
      <div className="flex justify-between items-center p-4 md:p-9 nmd:pb-8 flex-col md:flex-row">
        <div className="w-full mb-4 md:mb-0">
          <p className="text-xl font-bold mb-3">Solicitação {data.id}</p>
          <p className="">
            Aberto em <strong>{new Date(data.createdAt).toLocaleString()}</strong>
          </p>
          <p className="">
            {(data?.codCliente && data?.descricaoCliente ? `${data.codCliente} - ` : "").toUpperCase()}{" "}
            {nameOnly.toUpperCase()} - {cpfOrCnpj}
          </p>
          <p className="">
            Solicitação de: <strong>{temas[data.tipoSolicitacao]}</strong>
          </p>
          {data.infoPlus && <p className="">{displayInfoPlus(data.infoPlus).toUpperCase()}</p>}
          {(data?.tipoSolicitacao == 1 || data?.tipoSolicitacao == 3) && data?.cep && <p className=""> CEP: <strong>{data?.cep}</strong></p>}
        </div>
        <div className="flex flex-col md:items-end w-full items-center">
          <StatusFlag
            status={formatedStatus(data.statusSolicitacaoId)}
            className="mb-4 pb-4 border-b-2 w-full md:w-auto justify-center"
          />
        </div>
      </div>
      <div
        className={`font-bold cursor-pointer transition-all hover:text-terciaria button-box border-t text-center py-4`}
        onClick={() => setIsObsOpen((prevState) => !prevState)}
      >
        <span className={` button-show ${isObsOpen && "active"} ${formatedStatus(data.statusSolicitacaoId)}`} />
        <span>
          <p>{isObsOpen ? "Exibir menos" : "Exibir mais"}</p>
        </span>
      </div>
      <Collapse in={isObsOpen}>
        <Box className={`mx-2 px-9 py-8 rounded-md rounded-tr-none border bg-[#E9EAEF] z-0 relative`}>
          <div className="flex flex-col items-center">
            <p className="font-bold tracking-wide	 text-xl mb-2 uppercase">Observações</p>
            <p className="text-[#727272] text-center">
              {formatedStatus(data.statusSolicitacaoId) == "pendente" ? "Solicitação em Análise" : data.observacao}
            </p>
            {data.aprovador && (
              <p className="text-[#727272] text-center">
                Aprovador: <strong>{data.aprovador}</strong>
              </p>
            )}
            {data.statusSolicitacaoId === 3 && (
             <button
             onClick={() => NovaSolicitacao(data)}
             className={`col-span-1 button-search flex py-4 px-8 bg-secundaria gap-3 font-bold text-lg justify-center items-center mt-4 rounded-full ${data.observacao === 'Já existe uma solicitação de crédito VC em aberto.' ? 'opacity-50 cursor-not-allowed' : ''}`}
             disabled={data.observacao === 'Já existe uma solicitação de crédito VC em aberto.'}
           >
             Nova Solicitação
           </button>

            )}
            {data.statusSolicitacaoId === 4 && (
              <button
                onClick={() => ReenviarSolicitacao(data)}
                className="col-span-1 button-search flex py-4 px-8 bg-secundaria gap-3 font-bold text-lg justify-center items-center mt-4 rounded-full"
              >
                Reenviar solicitação
              </button>
            )}
          </div>
        </Box>
      </Collapse>
      {/* )} */}
    </div>
  );
}

export default RequestCard;
